import {
  AccountingTransactionsConfirmInvoicePaymentApiArg,
  useAccountingTransactionsConfirmInvoicePaymentMutation,
} from "../../../features/accountingTransaction/accountingTransaction-api";
import {useAppSelector} from "../../../store";
import {
  useWorkflowExecutionMutation,
  WorkflowExecutionApiArg,
  WorkflowExecutionResultDto,
} from "../../../features/workflowTriggers/workflowExecution-api";
import {toastError} from "../../../common/utils/toastMessages";
import {useWorkflowIds} from "../../../common/OrganizationConfig/useWorkflowIds";

export type CardValues = {
  number: string;
  expire: string;
  cvv: string;
  cardHolder: string;
};

export const usePayInvoice = (accountingTransactionId: number) => {
  const [confirmInvoicePaymentCommand] =
    useAccountingTransactionsConfirmInvoicePaymentMutation();

  const [useWorkflow] = useWorkflowExecutionMutation();

  const {createPaymentWorkflowId, applyCreditWorkflowId} = useWorkflowIds();

  const customerId = useAppSelector((state: any) => state.userState?.contactId);

  const applyCredit = async (
    accountingTransactionId: number,
    creditAmount: number,
  ) => {
    const variables = {
      contactId: customerId,
      invoiceApplications: [
        {
          invoiceId: accountingTransactionId,
          amountToApply: creditAmount,
        },
      ],
    };
    const commandArgs: WorkflowExecutionApiArg = {
      organizationId: process.env
        .REACT_APP_PORTAL_ORGANIZATION_ID as unknown as number,
      workflowId: applyCreditWorkflowId,
      values: {variables},
    };
    const result = (await useWorkflow(
      commandArgs,
    )) as WorkflowExecutionResultDto;
    if (result.error) {
      toastError("Failed apply credit for invoice.");
    }
  };

  const payInvoice = async (
    values: {
      contactPaymentMethodId?: string;
      card?: CardValues;
    },
    returnUrl: string,
    invoiceTotalAmount: number,
    creditAmount?: number | null,
  ) => {
    if (
      creditAmount !== null &&
      creditAmount !== undefined &&
      creditAmount > 0
    ) {
      await applyCredit(accountingTransactionId, creditAmount);

      if (creditAmount >= invoiceTotalAmount) {
        return {data: {redirectToUrl: returnUrl}};
      }
    }

    const variables = {
      ...values,
      accountingTransactionId,
      customerId,
    };
    const commandArgs: WorkflowExecutionApiArg = {
      organizationId: process.env
        .REACT_APP_PORTAL_ORGANIZATION_ID as unknown as number,
      workflowId: createPaymentWorkflowId,
      values: {variables},
    };
    const result = (await useWorkflow(
      commandArgs,
    )) as WorkflowExecutionResultDto;
    if (result.error) {
      toastError(result);
    } else {
      return {data: {redirectToUrl: returnUrl}};
    }
  };

  const confirmInvoicePayment = async (payment_intent: string) => {
    const commandArgs: AccountingTransactionsConfirmInvoicePaymentApiArg = {
      organizationId: process.env
        .REACT_APP_PORTAL_ORGANIZATION_ID as unknown as number,
      confirmInvoicePaymentCommandValues: {
        accountingTransactionId,
        paymentIntentId: payment_intent,
      },
    };
    return confirmInvoicePaymentCommand(commandArgs);
  };

  return {
    payInvoice,
    confirmInvoicePayment,
  };
};
